//TODO: turn this back on, once we have bots creation
import { useState } from 'react';

import { useTheme } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import Stack from '@mui/material/Stack';

import {
  StyledAccordion,
  StyledDivider,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  StyledPopper,
  StyledStack,
} from '@webclient/components/pages/home/sections/bots/content/filter/styles';

import CONFIG from '@webclient/lib/const/bots';

import useResponsive from '@webclient/hooks/useResponsive';

// import useWorkspace from '@webclient/hooks/useWorkspace';
import {
  AllBotsCategoryType,
  AllBotsCreatorType,
  SortBotsValueType,
} from '@webclient/shared-types/bots';

// import ArrowDownRounded from '~icons/knowz-iconify/arrow-down-rounded';
import CheckRoundedIcon from '~icons/knowz-iconify/check-rounded';
import ChevDownIcon from '~icons/knowz-iconify/chev-down';
import DotsVerticalIcon from '~icons/knowz-iconify/dots-vertical';
import FilterLinesRoundedIcon from '~icons/knowz-iconify/filter-lines-rounded';

import { IconButton, Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

type Props = {
  handleFilterByCategory: (category: AllBotsCategoryType) => void;
  handleFilterByCreator: (creator: AllBotsCreatorType) => void;
  toggleOrder: VoidFunction;
  currentCategory: AllBotsCategoryType;
  currentCreator: AllBotsCreatorType;
  order: SortBotsValueType;
};

export default function Filter({
  handleFilterByCategory,
  // handleFilterByCreator,
  // toggleOrder,
  currentCategory,
  // currentCreator,
  // order,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  // const { isWorkspace } = useWorkspace();
  const theme = useTheme();
  const { t } = useTranslate();
  const open = Boolean(anchorEl);
  const isItDesktop = useResponsive('up', 'md');
  const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // const shouldShowClearFilters =
  //   currentCategory !== 'All' || currentCreator !== 'Everyone';

  // function getAllCateforiesExceptKnowzInWorkspace({
  //   name,
  // }: (typeof CONFIG.ALL_CREATORS)[number]) {
  //   return isWorkspace ? name !== 'Knowz' : name;
  // }

  return (
    <>
      <IconButton
        variant="ghost"
        onClick={handleOpenPopover}
      >
        {isItDesktop ? <FilterLinesRoundedIcon /> : <DotsVerticalIcon />}
      </IconButton>

      <StyledPopper
        open={open}
        aria-label="character popover"
        anchorEl={anchorEl}
        placement="bottom-end"
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Box>
            <StyledAccordion
              component={List}
              disableGutters
              defaultExpanded
            >
              <StyledListItemButton
                component={AccordionSummary}
                disableRipple
                disableTouchRipple
                expandIcon={<ChevDownIcon />}
              >
                <StyledListItemText
                  primary={
                    <Text
                      variant="textSm"
                      weight="semibold"
                      color="text.secondary"
                    >
                      {t(
                        'page.home.gamification.filters.filterByCat',
                        'Filter by Category',
                      )}
                    </Text>
                  }
                />
              </StyledListItemButton>

              <StyledDivider as="div" />

              {CONFIG.ALL_CATEGORIES.map(({ name, icon, value }) => (
                <StyledListItemButton
                  component={AccordionDetails}
                  key={value}
                  disableRipple
                  disableTouchRipple
                  onClick={() => handleFilterByCategory(value)}
                >
                  <StyledStack>
                    <Stack direction="row">
                      <StyledListItemIcon>{icon}</StyledListItemIcon>
                      <Text
                        variant="textSm"
                        weight="semibold"
                        color="text.secondary"
                      >
                        {name}
                      </Text>
                    </Stack>
                    {currentCategory === value && (
                      <ListItemIcon>
                        <CheckRoundedIcon
                          color={theme.palette.utility.brand600}
                        />
                      </ListItemIcon>
                    )}
                  </StyledStack>
                </StyledListItemButton>
              ))}
            </StyledAccordion>

            <StyledDivider as="div" />

            {/* <StyledAccordion
              component={List}
              defaultExpanded
              disableGutters
            >
              <StyledListItemButton
                component={AccordionSummary}
                disableRipple
                disableTouchRipple
                expandIcon={<ChevDownIcon />}
              >
                <StyledListItemText
                  primary={
                    <Text
                      variant="textSm"
                      weight="semibold"
                      color="text.secondary"
                    >
                      {t(
                        'page.home.gamification.filters.filterByCreator',
                        'Filter by Creator',
                      )}
                    </Text>
                  }
                />
              </StyledListItemButton>

              <StyledDivider as="div" />

              {CONFIG.ALL_CREATORS.filter(
                getAllCateforiesExceptKnowzInWorkspace,
              ).map(({ icon, name, value }) => (
                <StyledListItemButton
                  disableRipple
                  disableTouchRipple
                  component={AccordionDetails}
                  onClick={() => handleFilterByCreator(value)}
                  key={value}
                >
                  <StyledStack>
                    <Stack direction="row">
                      <StyledListItemIcon>{icon}</StyledListItemIcon>
                      <Text
                        variant="textSm"
                        weight="semibold"
                        color="text.secondary"
                      >
                        {name}
                      </Text>
                    </Stack>

                    {currentCreator === value && (
                      <ListItemIcon>
                        <CheckRoundedIcon
                          color={theme.palette.utility.brand700}
                        />
                      </ListItemIcon>
                    )}
                  </StyledStack>
                </StyledListItemButton>
              ))}
            </StyledAccordion> 

            <StyledDivider as="div" />

            <StyledAccordion
              component={List}
              defaultExpanded
              disableGutters
            >
              <StyledListItemButton
                component={AccordionSummary}
                disableRipple
                disableTouchRipple
                expandIcon={<ChevDownIcon />}
              >
                <StyledListItemText
                  primary={
                    <Text
                      variant="textSm"
                      weight="semibold"
                      color="text.secondary"
                    >
                      {t('page.home.gamification.filters.sortBy', 'Sort by')}
                    </Text>
                  }
                />
              </StyledListItemButton>

              <StyledDivider as="div" />

              {CONFIG.ALL_SORTS.map(({ icon, name, value }) => (
                <StyledListItemButton
                  disableRipple
                  disableTouchRipple
                  component={AccordionDetails}
                  key={value}
                  onClick={toggleOrder}
                >
                  <StyledStack>
                    <Stack direction="row">
                      <StyledListItemIcon>{icon}</StyledListItemIcon>
                      <Text
                        variant="textSm"
                        weight="semibold"
                        color="text.secondary"
                      >
                        {name}
                      </Text>
                    </Stack>
                    <ListItemIcon>
                      <ArrowDownRounded
                        style={{
                          rotate: order === 'DESC' ? '0turn' : '0.5turn',
                          color: theme.palette.utility.brand700,
                        }}
                      />
                    </ListItemIcon>
                  </StyledStack>
                </StyledListItemButton>
              ))}
              {shouldShowClearFilters && (
                <StyledListItemButton
                  disableRipple
                  disableTouchRipple
                  component={AccordionDetails}
                  onClick={() => {
                    handleFilterByCategory('All');
                    handleFilterByCreator('Everyone');
                  }}
                >
                  <StyledListItemIcon>&times;</StyledListItemIcon>
                  <Text
                    variant="textSm"
                    weight="semibold"
                    color="text.secondary"
                  >
                    {t(
                      'page.home.gamification.filters.clearFilters',
                      'Clear Filters',
                    )}
                  </Text>
                </StyledListItemButton>
              )}
            </StyledAccordion>
            */}
          </Box>
        </ClickAwayListener>
      </StyledPopper>
    </>
  );
}
